import axios from 'axios';

axios.defaults.withCredentials = true;

export default class ApiService
{
    static API_BASE_PATH: string = `${process.env.VUE_APP_REST_API_PATH}`;

	public static getTimestampForTimezone(sourceDate : Date, timeZone : string) : number
	{
        const timestamp = sourceDate.getTime();
		const date: Date = new Date(timestamp);
		const formatter: Intl.DateTimeFormat = new Intl.DateTimeFormat('en-US',
		{
    		timeZone,
		    year: 'numeric',
		    month: '2-digit',
		    day: '2-digit',
		    hour: '2-digit',
		    minute: '2-digit',
		    second: '2-digit',
		});

	  	return Math.floor(new Date(formatter.format(date)).getTime() / 1000);
	}

	public static async getAllQuestionnairesView()
    {
        try
        {
            let params = 
            {
                v: "v_questionnaires_overview"
            }

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as QuestionnaireView[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getQuestionnaireRisk(model : QuestionnaireView)
    {
        try
        {
            let params = 
            {
                v: "v_questionnaire_risk",
                w: `questionnaireid = ${model.questionnaireid}`
            }

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as QuestionnaireRisk[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getReportView(filter : FilterModel)
    {
        let where : string = " true ";

        if (filter.selectedCustomers.length > 0)
        {
            where += " AND customerid IN (" + filter.selectedCustomers.join(",") + ") "
        }

        if (filter.selectedLocations.length > 0)
        {
            where += " AND locationid IN (" + filter.selectedLocations.join(",") + ") "
        }
        
        if (filter.selectedDepartments.length > 0)
        {
            where += " AND departmentid IN (" + filter.selectedDepartments.join(",") + ") "
        }

        if (filter.selectedCategories.length > 0)
        {
            where += " AND questionnaireid IN (SELECT questionnaireid FROM question WHERE categoryid IN (" + filter.selectedCategories.join(",") + ")) "
        }

        if (filter.selectedQuestionnaires.length > 0)
        {
            where += " AND questionnaireid IN (" + filter.selectedQuestionnaires.join(",") + ") "
        }

        if (filter.selectedAttributes.length > 0)
        {
            where += " AND questionnaireid IN (SELECT questionnaireid FROM questionnaire WHERE customerid IN (SELECT customerid FROM questionnaire WHERE questionnaireid IN (SELECT questionnaireid FROM participant WHERE participantid IN (SELECT participantid FROM participant_choice WHERE attributeid IN (" + filter.selectedAttributes.join(",") + "))))) "
        }

        try
        {
            let params = 
            {
                v: "v_questionnaires_overview",
                w: where
            }

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as QuestionnaireView[];
                }
            }
        }
        catch (error)
        {
        }
    }
	
	public static async getQuestionnaire(questionnaireid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/questionnaire/${questionnaireid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as QuestionnaireModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async createQuestionnaire(record : QuestionnaireModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/questionnaire/`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as QuestionnaireModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async copyQuestionnaire(recordNew : QuestionnaireModel, recordTemplate : QuestionnaireModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/questionnaire/${recordTemplate.questionnaireid}/copy`, recordNew);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as QuestionnaireModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async deleteQuestionnaire(record : QuestionnaireModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/questionnaire/${record.questionnaireid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
        }

        return false;
    }
	public static async getAllContactsByCustomerId(customerid : string)
    {
        try
        {
			let params = 
			{	
				v: 'v_contact_all',
				w: `customerid = ${customerid}`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ContactModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

	
	public static async getAllLocationsByCustomerId(customerid : string)
    {
        try
        {
			let params = 
			{	
				v: 'v_locations_all',
				w: `customerid = ${customerid}`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as LocationModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getAllDepartmentsByLocationId(locationid : string)
    {
        try
        {
			let params = 
			{	
				v: 'v_departments_all',
				w: `locationid = ${locationid}`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as DepartmentModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getAllUsers()
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/user/available`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as UserModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getUser(userid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/user/${userid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as UserModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async createUser(record: UserModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/user/`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as UserModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async updateUser(record: UserModel)
    {
        try
        {
            let response = await axios.put(`${ApiService.API_BASE_PATH}/user/`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as UserModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async deleteUser(user : UserModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/user/${user.userid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
        }

        return false;
    }

    public static async patchUser(record: UserModel)
    {
        try
        {
            let response = await axios.patch(`${ApiService.API_BASE_PATH}/user/`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as UserModel;
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getAllPermission()
    {
        try
        {
			let params = 
			{
				v: "v_permissions_all",
                o: "permissionid ASC"
			}
            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as PermissionModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getPermissionsForRole(roleid : string)
    {
        try
        {
			let params = 
			{
				v: "v_role_permission_all",
				w: `roleid = ${roleid}`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as RolePermissionModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async setRolePermission(roleid : number, permissionid : number, permitted : boolean)
    {
        try
        {
            if (permitted)
            {
				let model : RolePermissionModel = {} as RolePermissionModel;
				model.roleid = roleid;
				model.permissionid = permissionid;

                let response = await axios.post(`${ApiService.API_BASE_PATH}/role_permission/`, model);

                if (response && response.status === 201)
                {
                    if (response.data)
                    {
                        return response.data as RolePermissionModel[];
                    }
                }
            }
            else
            {
                let response = await axios.delete(`${ApiService.API_BASE_PATH}/role_permission/${permissionid}/${roleid}`);

                if (response && response.status === 204)
                {
                    return true;
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getCategory(categoryid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/category/${categoryid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as CategoryModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

	public static async getQuestionCategories(questionid : string)
    {
        try
        {
			let params = 
			{
				v: 'v_question_category_all',
				w: `questionid = ${questionid}`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as QuestionCategoryModel[];
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

	public static async createCategory(record : CategoryModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/category/`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as CategoryModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

    public static async updateCategory(record : CategoryModel)
    {
        try
        {
            let response = await axios.put(`${ApiService.API_BASE_PATH}/category/`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as CategoryModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

    public static async deleteCategory(record : CategoryModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/category/${record.categoryid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }

        return false;
    }

	public static async getAllCategories()
    {
        try
        {
			let params = 
			{
				v: "v_categories_all",
				o: "name ASC"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as CategoryModel[];
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

	public static async getAllSources()
    {
        try
        {
			let params = 
			{
				v: "v_sources_all",
				o: "name ASC"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as SourceModel[];
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

    public static async getAllCategoriesForQuestionnaire(questionnaireid : string)
    {
        try
        {
			let params = 
			{
				v: "v_categories_all",
				w: `categoryid IN (SELECT categoryid FROM question WHERE questionnaireid = ${questionnaireid})`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as CategoryModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getNextCategoryForQuestionnaire(questionnaireid : string, participantid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/view/nextcategory/${questionnaireid}/${participantid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as CategoryModel;
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getTargetGroup(targetgroupid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/targetgroup/${targetgroupid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TargetGroupModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

	public static async getQuestionTargetGroups(questionid : string)
    {
        try
        {
			let params = 
			{
				v: 'v_question_targetgroup_all',
				w: `questionid = ${questionid}`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as QuestionTargetGroupModel[];
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

	public static async createTargetGroup(record : TargetGroupModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/targetgroup/`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as TargetGroupModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

    public static async updateTargetGroup(record : TargetGroupModel)
    {
        try
        {
            let response = await axios.put(`${ApiService.API_BASE_PATH}/targetgroup/`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TargetGroupModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

    public static async deleteTargetGroup(record : TargetGroupModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/targetgroup/${record.targetgroupid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }

        return false;
    }

	public static async getAllTargetGroups()
    {
        try
        {
			let params = 
			{
				v: "v_targetgroup_all",
				o: "targetgroupid ASC"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TargetGroupModel[];
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

	public static async addQuestionTargetGroup(record : QuestionTargetGroupModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/question_targetgroup/`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as QuestionTargetGroupModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getQuestionTargetGroup(questionid : string, targetgroupid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/question_targetgroup/${questionid}/${targetgroupid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as QuestionTargetGroupModel;
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async removeQuestionTargetGroup(questionid : string, targetgroupid : string)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/question_targetgroup/${questionid}/${targetgroupid}`);

            if (response && response.status === 200)
            {
                
                return true;
            }
        }
        catch (error)
        {
        }
    }

	public static async getAllContactTypes()
    {
        try
        {
			let params = 
			{
				v: "v_contacttype_all"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ContactTypeModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getContactType(contacttypeid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/contacttype/${contacttypeid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ContactTypeModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async createContact(record : ContactModel)
    {
        try
        {
            console.log(record);

            let response = await axios.post(`${ApiService.API_BASE_PATH}/contact/`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as ContactModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async updateContact(record: ContactModel)
    {
        try
        {
            let response = await axios.put(`${ApiService.API_BASE_PATH}/contact/`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ContactModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async deleteContact(record : ContactModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/contact/${record.contactid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
        }

        return false;
    }

	public static async getChoice(choiceid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/choice/${choiceid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ChoiceModel;
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async createChoice(record : ChoiceModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/choice/`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as ChoiceModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async updateChoice(choice: ChoiceModel)
    {
        try
        {
        let response = await axios.put(`${ApiService.API_BASE_PATH}/choice/`, choice);

        if (response && response.status === 200)
        {
            if (response.data)
            {
                return true;
            }
        }
        }
        catch (error)
        {
        }
    }

    public static async deleteChoice(record : ChoiceModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/choice/${record.choiceid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
        }

        return false;
    }

    public static async reorderChoice(choice: ChoiceModel)
    {
        try
        {
            let response = await axios.patch(`${ApiService.API_BASE_PATH}/choice/reorder/`, choice);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ChoiceModel;
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getAllChoicesForAttribute(attributeid : string)
    {
        try
        {
			let params = 
			{
				v: "v_choices_all",
				w: `attributeid = ${attributeid}`,
                o: "position"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ChoiceModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getAllCustomers()
    {
        try
        {
			let params = 
			{
				v: "v_customer_all",
				o: "customerid ASC"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as CustomerModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getCustomer(customerid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/customer/${customerid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as CustomerModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async createCustomer(record : CustomerModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/customer/`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as CustomerModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async updateCustomer(record : CustomerModel)
    {
        try
        {
            let response = await axios.put(`${ApiService.API_BASE_PATH}/customer/`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as CustomerModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async deleteCustomer(record : CustomerModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/customer/${record.customerid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
        }

        return false;
    }

	public static async getAllClients()
    {
        try
        {
			let params = 
			{
				v: "v_client_all",
				o: "clientid ASC"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ClientModel[];
                }
            }
        }
        catch (error)
        {
        }
    }


	public static async getClientListForCustomer(customerid : string)
    {
        try
        {
			let params = 
			{
				v: "v_client_all",
                w: `customerid = ${customerid}`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ClientModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getClient(clientid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/client/${clientid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ClientModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async createClient(record : ClientModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/client/`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as ClientModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async updateClient(record : ClientModel)
    {
        try
        {
            let response = await axios.put(`${ApiService.API_BASE_PATH}/client/`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ClientModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async patchClient(record : ClientModel)
    {
        try
        {
            let response = await axios.patch(`${ApiService.API_BASE_PATH}/client/`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return true;
                }
            }
        }
        catch (error)
        {
        }

        return false;
    }

    public static async deleteClient(record : ClientModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/client/${record.clientid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
        }

        return false;
    }

	public static async getAllOptionsForQuestion(questionid : string, filter : string | undefined, sortfield : string = 'position')
    {
        try
        {
            let filterSQL : string = "TRUE";

            if (filter && filter.length > 0)
            {
               filterSQL = `LOWER("option") LIKE '%${filter.toLowerCase()}%'`;
            }

			let params = 
			{
				v: "v_options_all",
				w: `questionid = ${questionid} AND ${filterSQL}`,
                o: `${sortfield} ASC`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as OptionModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getAllOptions()
    {
        try
        {
			let params = 
			{
				v: "v_optiopns_all",
				o: "position ASC"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as OptionModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async appendOptions(sourceid : string, targetid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/question/option/copy/${sourceid}/${targetid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return Number(response.data);
                }
            }
        }
        catch (error)
        {
        }

        return false;
    }

    public static async getOptionCountsByTargetgroup(targetgroupid : string)
    {
        try
        {
			let params = 
			{
				v: "v_option_cnt",
                w: `targetgroupid = ${targetgroupid}`,
				o: "targetgroupid, difficulty ASC"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as OptionCountModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getMaxOptionPosition(questionid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/question/${questionid}/option/max`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return Number(response.data);
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getOption(optionid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/option/${optionid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as OptionModel;
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async createOption(record : OptionModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/option`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as OptionModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async updateOption(record: OptionModel)
    {
        try
        {
	        let response = await axios.put(`${ApiService.API_BASE_PATH}/option`, record);
	
    	    if (response && response.status === 200)
        	{
            	if (response.data)
	            {
    	            return true;
        	    }
	        }
    	}
        catch (error)
        {
        }
    }

    public static async lockOption(record : OptionModel)
    {
        try
        {
            let response = await axios.patch(`${ApiService.API_BASE_PATH}/option/${record.optionid}`);

            if (response && response.status === 200)
            {
                return true;
            }
        }
        catch (error)
        {
        }

        return false;
    }

    public static async deleteOption(record : OptionModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/option/${record.optionid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
        }

        return false;
    }

	public static async reorderOption(record: OptionModel)
    {
        try
        {
            let response = await axios.patch(`${ApiService.API_BASE_PATH}/option`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as OptionModel;
                }
            }
        }
        catch (error)
        {
        }
    }
	
	public static async getAllLocations()
    {
        try
        {
			let params = 
			{
				v: "v_locations_all",
				o: "name ASC"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as LocationModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getLocation(locationid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/location/${locationid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as LocationModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async createLocation(record: LocationModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/location/`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as LocationModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async updateLocation(record: LocationModel)
    {
        try
        {
            let response = await axios.put(`${ApiService.API_BASE_PATH}/location/`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as LocationModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async deleteLocation(record : LocationModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/location/${record.locationid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
        }

        return false;
    }

	public static async getAllDepartments()
    {
        try
        {
			let params = 
			{
				v: "v_departments_all",
				o: "name ASC"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as DepartmentModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getStats()
    {
        try
        {
			let params = 
			{
				v: "v_status_counts"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data[0] as StatsModel;
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getAllContacts()
    {
        try
        {
			let params = 
			{
				v: "v_contact_all",
				o: "name ASC"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ContactModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getContact(contactid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/contact/${contactid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ContactModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async createContact(record: ContactModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/contact/`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as ContactModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async updateContact(record: ContactModel)
    {
        try
        {
            let response = await axios.put(`${ApiService.API_BASE_PATH}/contact/`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ContactModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async deleteContact(record : ContactModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/contact/${record.contactid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
        }

        return false;
    }

    public static async getAllRoles()
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/role/available`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as RoleModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getRole(roleid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/role/${roleid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as RoleModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async createRole(record: RoleModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/role/`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as RoleModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async updateRole(record: RoleModel)
    {
        try
        {
            let response = await axios.put(`${ApiService.API_BASE_PATH}/role/`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as UserModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async deleteRole(record : RoleModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/role/${record.roleid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
        }

        return false;
    }

    public static async patchRole(record: RoleModel)
    {
        try
        {
            let response = await axios.patch(`${ApiService.API_BASE_PATH}/role/${record.roleid}`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as RoleModel;
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getAllTokenList()
    {
        try
        {
			let params = 
			{
				v: "v_tokenlist_all"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TokenListModel[];
                }
            }
        }
        catch (error)
        {
        }
    }
	
	public static async getAllUnusedTokensForTest()
    {
        try
        {
			let params = 
			{
				v: "v_tokenlist_all"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TokenListModel[];
                }
            }
        }
        catch (error)
        {
        }
    }
	
	public static async createTokenList(record : TokenListModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/tokenlist`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as TokenListModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async updateTokenList(record: TokenListModel)
    {
        try
        {
        let response = await axios.put(`${ApiService.API_BASE_PATH}/tokenlist/${record.tokenlistid}`, record);

        if (response && response.status === 200)
        {
            if (response.data)
            {
                return true;
            }
        }
        }
        catch (error)
        {
        }
    }

    public static async deleteTokenList(record : TokenListModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/tokenlist/${record.tokenlistid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
        }

        return false;
    }

    public static async generateTokens(tokenlistid : number, amount : number)
    {
        try
        {
            let response = await axios.patch(`${ApiService.API_BASE_PATH}/tokenlist/${tokenlistid}/addtokens/${amount}`);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as string;
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getTokenList(tokenlistid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/tokenlist/${tokenlistid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TokenListModel;
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getTokenListsForCustomer(customerid : string)
    {
        try
        {
			let params = 
			{
				v: "v_tokenlist_overview",
                w: `customerid = ${customerid}`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TokenListView[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getAllTokensByTokenList(tokenlistid : string)
    {
        try
        {
			let params = 
			{
				v: "v_token_all",
				w: `tokenlistid = ${tokenlistid}`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TokenModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getAllUnusedTokensByTokenList(tokenlistid : string)
    {
        try
        {
			let params = 
			{
				v: "v_token_all",
				w: `tokenlistid = ${tokenlistid} AND tokenid NOT IN (SELECT tokenid FROM participant)`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TokenModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getAllToken()
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/token`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TokenModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getAllTokenForListView(tokenlistid : string, page : string, count : string) 
    {
        try
        {
			let params = 
			{
				v: "v_token_all",
				w: `tokenlistid = ${tokenlistid}`,
				p: page,
				c: count
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TokenView[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getToken(tokenid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/token/${tokenid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TokenModel;
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async addQuestionCategory(record : QuestionCategoryModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/question_category/`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as QuestionCategoryModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getQuestionCategory(questionid : string, categoryid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/question_category/${questionid}/${categoryid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as QuestionCategoryModel;
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async removeQuestionCategory(questionid : string, categoryid : string)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/question_category/${questionid}/${categoryid}`);

            if (response && response.status === 200)
            {
                
                return true;
            }
        }
        catch (error)
        {
        }
    }

	public static async setCustomerBanner(customerid : string, data : Blob)
    {
        try
        {
            let formData : FormData = new FormData();
            formData.append("file", data, "test.png");
            let response = await axios.post(`${ApiService.API_BASE_PATH}/customer/${customerid}/banner`, formData);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return true;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getCustomerBanner(customerid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/customer/${customerid}/banner`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async removeCustomerBanner(customerid : string)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/customer/${customerid}/banner`);

            if (response && response.status === 200)
            {
                
                return true;
            }
        }
        catch (error)
        {
        }
    }

    public static async getCustomerBannerThumbnail(customerid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/customer/${customerid}/banner/thumb`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response;
                }
            }
        }
        catch (error)
        {
        }
    }
    
    public static async getTableCount(table : string, where : string) : Promise<number>
    {
        try
        {
			let params = 
			{
				t: table,
				w: where,
				i: "count",
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view/info`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data["count"] as number;
                }
            }
        }
        catch (error)
        {
        }

        return -1;
    }

	public static async getDepartment(departmentid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/department/${departmentid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as DepartmentModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async createDepartment(record : DepartmentModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/department`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as DepartmentModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async updateDepartment(record : DepartmentModel)
    {
        try
        {
            let response = await axios.put(`${ApiService.API_BASE_PATH}/department`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as DepartmentModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async deleteDepartment(record : DepartmentModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/department/${record.departmentid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
        }

        return false;
    }

	public static async getAllQuestionsForQuestionnaire(questionnaireid : string)
    {
        try
        {
			let params =
			{
				v: "v_question_all",
				w: `questionnaireid = ${questionnaireid}`,
                o: "position"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as QuestionModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getAllQuestions()
    {
        try
        {
			let params =
			{
				v: "v_question_all",
                o: "position"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as QuestionModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getQuestion(questionid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/question/${questionid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as QuestionModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async createQuestion(record : QuestionModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/question/`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as QuestionModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async updateQuestion(question: QuestionModel)
    {
        try
        {
			let response = await axios.put(`${ApiService.API_BASE_PATH}/question/`, question);

			if (response && response.status === 200)
			{
				if (response.data)
				{
					return true;
				}
			}
        }
        catch (error)
        {
        }
    }

    public static async deleteQuestion(record : QuestionModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/question/${record.questionid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
        }

        return false;
    }

	public static async getAllParticipant()
    {
        try
        {
			let params = 
			{
				v: 'v_participant_all'
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ParticipantModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getParticipantsForTest(testid : string)
    {
        try
        {
			let params = 
			{
				v: 'v_participant_all',
				w: `testid = ${testid}`,
                o: `prefix, token`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ParticipantModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getActiveParticipantsForTest(testid : string)
    {
        try
        {
			let params = 
			{
				v: 'v_participant_all',
				w: `testid = ${testid} AND (datelogin > 0 OR datestart > 0)`,
                o: `prefix, token`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ParticipantModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getParticipantForToken(tokenid : string)
    {
        try
        {
			let params = 
			{
				v: 'v_participant_all',
				w: `tokenid = ${tokenid}`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ParticipantModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async createParticipant(record : ParticipantModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/participant`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as ParticipantModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async updateParticipant(record: ParticipantModel)
    {
        try
        {
            let response = await axios.put(`${ApiService.API_BASE_PATH}/participant`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ParticipantModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async deleteParticipant(record : ParticipantModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/participant/${record.participantid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
        }

        return false;
    }

	public static async getAllQuestionnaireForCustomer(customerid : string)
    {
        try
        {
            let params = 
            {
                v: "v_questionnaire_all",
                w: `customerid = ${customerid}`
            }

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as QuestionnaireModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getQuestionnaireFromToken(tokenid : string)
    {

        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/questionnaire/token/${tokenid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as QuestionnaireModel;
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getReportSummary(questionnaireid : string)
    {
        try
        {
            let params = 
            {
                v: "v_report_summary",
                w: `questionnaireid = ${questionnaireid} AND isdone = true`
            }

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ReportSummaryView[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getReportDetail(questionnaireid : string, categoryid : string)
    {
        try
        {
            let params = 
            {
                v: "v_report_summary",
                w: `questionnaireid = ${questionnaireid} AND categoryid = ${categoryid}`
            }

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ReportSummaryView[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getReportTable(fields : string, where : string, group :string, order : string, filter : FilterModel)
    {
        try
        {
            if (filter.selectedCustomers.length > 0)
            {
                where += " AND customerid IN (" + filter.selectedCustomers.join(",") + ") "
            }

            if (filter.selectedLocations.length > 0)
            {
                where += " AND locationid IN (" + filter.selectedLocations.join(",") + ") "
            }

            if (filter.selectedDepartments.length > 0)
            {
                where += " AND departmentid IN (" + filter.selectedDepartments.join(",") + ") "
            }
            
            if (filter.selectedCategories.length > 0)
            {
                where += " AND categoryid IN (" + filter.selectedCategories.join(",") + ") "
            }

            if (filter.selectedAttributes.length > 0)
            {
                where += " AND attributeid IN (" + filter.selectedAttributes.join(",") + ") "
            }

            if (filter.selectedQuestionnaires.length > 0)
            {
                where += " AND questionnaireid IN (" + filter.selectedQuestionnaires.join(",") + ") "
            }

            if (filter.selectedQuestions.length > 0)
            {
                where += " AND questionid IN (" + filter.selectedQuestions.join(",") + ") "
            }

            let params = 
            {
                v: "v_report_all",
                f: fields,
                w: where,
                g: group,
                o: order
            }

            //console.log(fields);

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ReportTable[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getAllCustomerByFilter(filter : FilterModel)
    {
        let where : string = " true ";

        if (filter.selectedLocations.length > 0)
        {
            where += " AND customerid IN (SELECT customerid FROM location WHERE locationid IN (" + filter.selectedLocations.join(",") + ")) "
        }
        
        if (filter.selectedDepartments.length > 0)
        {
            where += " AND customerid IN (SELECT customerid FROM location WHERE locationid IN (SELECT locationid FROM department WHERE departmentid IN (" + filter.selectedDepartments.join(",") + "))) "
        }

        if (filter.selectedCategories.length > 0)
        {
            where += " AND customerid IN (SELECT customerid FROM questionnaire WHERE questionnaireid IN (SELECT questionnaireid FROM question WHERE categoryid IN (" + filter.selectedCategories.join(",") + "))) "
        }

        if (filter.selectedQuestionnaires.length > 0)
        {
            where += " AND customerid IN (SELECT customerid FROM questionnaire WHERE questionnaireid IN (" + filter.selectedQuestionnaires.join(",") + ")) "
        }

        if (filter.selectedAttributes.length > 0)
        {
            where += " AND customerid IN (SELECT customerid FROM questionnaire WHERE questionnaireid IN (SELECT questionnaireid FROM participant WHERE participantid IN (SELECT participantid FROM participant_choice WHERE attribiteid IN (" + filter.selectedAttributes.join(",") + ")))) "
        }

        if (filter.selectedQuestions.length > 0)
        {
            where += " AND customerid IN (SELECT customerid FROM questionnaire WHERE questionnaireid IN (SELECT questionnaireid FROM question WHERE questionid IN (" + filter.selectedQuestions.join(",") + "))) "
        }

        try
        {
            let params = 
            {
                v: "v_customer_all",
                w: where
            }

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as CustomerModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getAllLocationByFilter(filter : FilterModel)
    {
        let where : string = " true ";

        if (filter.selectedCustomers.length > 0)
        {
            where += " AND customerid IN (" + filter.selectedCustomers.join(",") + ") "
        }
        
        if (filter.selectedDepartments.length > 0)
        {
            where += " AND locationid IN (SELECT locationid FROM department WHERE departmentid IN (" + filter.selectedDepartments.join(",") + ")) "
        }

        if (filter.selectedCategories.length > 0)
        {
            where += " AND locationid IN (SELECT locationid FROM questionnaire WHERE questionnaireid IN (SELECT questionnaireid FROM question WHERE categoryid IN (" + filter.selectedCategories.join(",") + "))) "
        }

        if (filter.selectedQuestionnaires.length > 0)
        {
            where += " AND locationid IN (SELECT locationid FROM questionnaire WHERE questionnaireid IN (" + filter.selectedQuestionnaires.join(",") + ")) "
        }

        if (filter.selectedAttributes.length > 0)
        {
            where += " AND locationid IN (SELECT locationid FROM questionnaire WHERE questionnaireid IN (SELECT questionnaireid FROM participant WHERE participantid IN (SELECT participantid FROM participant_choice WHERE attribiteid IN (" + filter.selectedAttributes.join(",") + ")))) "
        }

        if (filter.selectedQuestions.length > 0)
        {
            where += " AND locationid IN (SELECT locationid FROM questionnaire WHERE questionnaireid IN (SELECT questionnaireid FROM question WHERE questionid IN (" + filter.selectedQuestions.join(",") + "))) "
        }


        try
        {
            let params = 
            {
                v: "v_locations_all",
                w: where
            }

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as LocationModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getAllDepartmentByFilter(filter : FilterModel)
    {
        let where : string = " true ";

        if (filter.selectedCustomers.length > 0)
        {
            where += " AND locationid IN (SELECT locationid FROM location WHERE customerid IN (" + filter.selectedCustomers.join(",") + ")) "
        }
        
        if (filter.selectedLocations.length > 0)
        {
            where += " AND locationid IN (" + filter.selectedLocations.join(",") + ") "
        }

        if (filter.selectedCategories.length > 0)
        {
            where += " AND locationid IN (SELECT locationid FROM questionnaire WHERE questionnaireid IN (SELECT questionnaireid FROM question WHERE categoryid IN (" + filter.selectedCategories.join(",") + "))) "
        }

        if (filter.selectedQuestionnaires.length > 0)
        {
            where += " AND locationid IN (SELECT locationid FROM questionnaire WHERE questionnaireid IN (" + filter.selectedQuestionnaires.join(",") + ")) "
        }

        if (filter.selectedAttributes.length > 0)
        {
            where += " AND locationid IN (SELECT locationid FROM questionnaire WHERE questionnaireid IN (SELECT questionnaireid FROM participant WHERE participantid IN (SELECT participantid FROM participant_choice WHERE attribiteid IN (" + filter.selectedAttributes.join(",") + ")))) "
        }

        if (filter.selectedQuestions.length > 0)
        {
            where += " AND departmentid IN (SELECT departmentid FROM questionnaire WHERE questionnaireid IN (SELECT questionnaireid FROM question WHERE questionid IN (" + filter.selectedQuestions.join(",") + "))) "
        }

        try
        {
            let params = 
            {
                v: "v_departments_all",
                w: where
            }

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as DepartmentModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getAllCategoryByFilter(filter : FilterModel)
    {
        let where : string = " true ";

        if (filter.selectedCustomers.length > 0)
        {
            where += " AND categoryid IN (SELECT categoryid FROM question WHERE questionnaireid IN (SELECT questionnaireid FROM questionnaire WHERE customerid IN (" + filter.selectedCustomers.join(",") + "))) "
        }

        if (filter.selectedLocations.length > 0)
        {
            where += " AND categoryid IN (SELECT categoryid FROM question WHERE questionnaireid IN (SELECT questionnaireid FROM questionnaire WHERE customerid IN (SELECT customerid FROM location WHERE locationid IN (" + filter.selectedLocations.join(",") + ")))) "
        }
        
        if (filter.selectedDepartments.length > 0)
        {
            where += " AND categoryid IN (SELECT categoryid FROM question WHERE questionnaireid IN (SELECT questionnaireid FROM questionnaire WHERE customerid IN (SELECT customerid FROM location WHERE locationid IN (SELECT locationid FROM department WHERE departmentid IN (" + filter.selectedDepartments.join(",") + "))))) "
        }

        if (filter.selectedQuestionnaires.length > 0)
        {
            where += " AND categoryid IN (SELECT categoryid FROM question WHERE questionnaireid IN (" + filter.selectedQuestionnaires.join(",") + ")) "
        }

        if (filter.selectedAttributes.length > 0)
        {
            where += " AND categoryid IN (SELECT categoryid FROM question WHERE questionnaireid IN (SELECT questionnaireid FROM questionnaire WHERE customerid IN (SELECT customerid FROM questionnaire WHERE questionnaireid IN (SELECT questionnaireid FROM participant WHERE participantid IN (SELECT participantid FROM participant_choice WHERE attribiteid IN (" + filter.selectedAttributes.join(",") + ")))))) "
        }

        if (filter.selectedQuestions.length > 0)
        {
            where += " AND categoryid IN (SELECT categoryid FROM question WHERE questionid IN (" + filter.selectedQuestions.join(",") + ")) "
        }

        try
        {
            let params = 
            {
                v: "v_categories_all",
                w: where
            }

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as CategoryModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getAllQuestionnaireByFilter(filter : FilterModel)
    {
        let where : string = " true ";

        if (filter.selectedCustomers.length > 0)
        {
            where += " AND customerid IN (" + filter.selectedCustomers.join(",") + ") "
        }

        if (filter.selectedLocations.length > 0)
        {
            where += " AND locationid IN (" + filter.selectedLocations.join(",") + ") "
        }
        
        if (filter.selectedDepartments.length > 0)
        {
            where += " AND departmentid IN (" + filter.selectedDepartments.join(",") + ") "
        }

        if (filter.selectedCategories.length > 0)
        {
            where += " AND questionnaireid IN (SELECT questionnaireid FROM question WHERE categoryid IN (" + filter.selectedCategories.join(",") + ")) "
        }

        if (filter.selectedAttributes.length > 0)
        {
            where += " AND questionnaireid IN (SELECT questionnaireid FROM questionnaire WHERE customerid IN (SELECT customerid FROM questionnaire WHERE questionnaireid IN (SELECT questionnaireid FROM participant WHERE participantid IN (SELECT participantid FROM participant_choice WHERE attributeid IN (" + filter.selectedAttributes.join(",") + "))))) "
        }

        if (filter.selectedQuestions.length > 0)
        {
            where += " AND questionnaireid IN (SELECT questionnaireid FROM question WHERE questionid IN (" + filter.selectedQuestions.join(",") + ")) "
        }

        try
        {
            let params = 
            {
                v: "v_questionnaire_all",
                w: where
            }

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as QuestionnaireModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getAllAttributeByFilter(filter : FilterModel)
    {
        let where : string = " true ";

        if (filter.selectedCustomers.length > 0)
        {
            where += " AND attributeid IN (SELECT attributeid FROM customer_attribute WHERE customerid IN (" + filter.selectedCustomers.join(",") + ")) "
        }

        if (filter.selectedLocations.length > 0)
        {
            where += " AND attributeid IN (SELECT attributeid FROM customer_attribute WHERE customerid IN (SELECT customerid FROM location WHERE locationid IN (" + filter.selectedLocations.join(",") + "))) "
        }
        
        if (filter.selectedDepartments.length > 0)
        {
            where += " AND attributeid IN (SELECT attributeid FROM customer_attribute WHERE customerid IN (SELECT customerid FROM location WHERE locationid IN (SELECT locationid FROM department WHERE departmentid IN (" + filter.selectedDepartments.join(",") + ")))) "
        }

        if (filter.selectedCategories.length > 0)
        {
            where += " AND attributeid IN (SELECT attributeid FROM customer_attribute WHERE customerid IN (SELECT customerid FROM questionnaire WHERE questionnaireid IN (SELECT questionnaireid FROM question WHERE categoryid IN (" + filter.selectedCategories.join(",") + ")))) "
        }

        if (filter.selectedQuestions.length > 0)
        {
            where += " AND (attributeid IN (SELECT attributeid FROM customer_attribute WHERE customerid IN (SELECT customerid FROM questionnaire WHERE questionnaireid IN (SELECT questionnaireid FROM question WHERE questionid IN (" + filter.selectedQuestions.join(",") + "))))) OR isdefault "
        }

        try
        {
            let params = 
            {
                v: "v_attributes_all",
                w: where
            }

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as AttributeModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getAllQuestionByFilter(filter : FilterModel)
    {
        let where : string = " true ";

        if (filter.selectedCustomers.length > 0)
        {
            where += " AND questionnaireid IN (SELECT questionnaireid FROM questionnaire WHERE customerid IN (" + filter.selectedCustomers.join(",") + ")) "
        }

        if (filter.selectedLocations.length > 0)
        {
            where += " AND questionnaireid IN (SELECT questionnaireid FROM questionnaire WHERE customerid IN (SELECT customerid FROM location WHERE locationid IN (" + filter.selectedLocations.join(",") + "))) "
        }
        
        if (filter.selectedDepartments.length > 0)
        {
            where += " AND questionnaireid IN (SELECT questionnaireid FROM questionaire WHERE customerid IN (SELECT customerid FROM location WHERE locationid IN (SELECT locationid FROM department WHERE departmentid IN (" + filter.selectedDepartments.join(",") + ")))) "
        }

        if (filter.selectedCategories.length > 0)
        {
            where += " AND categoryid IN (" + filter.selectedCategories.join(",") + ") "
        }

        if (filter.selectedQuestionnaires.length > 0)
        {
            where += " AND questionnaireid IN (" + filter.selectedQuestionnaires.join(",") + ") "
        }

        try
        {
            let params = 
            {
                v: "v_question_all",
                w: where
            }

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as QuestionModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getNote(questionnaireid : string, categoryid : string, notetype : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/note/${questionnaireid}/${categoryid}/${notetype}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as NoteModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async createNote(record : NoteModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/note`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as NoteModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async updateNote(record : NoteModel)
    {
        try
        {
            let response = await axios.put(`${ApiService.API_BASE_PATH}/note`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as NoteModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async deleteNote(record : NoteModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/note/${record.questionnaireid}/${categoryid}/${notetype}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
        }

        return false;
    }

	public static async getTest(testid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/test/${testid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TestModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

	public static async createTest(record : TestModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/test/`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as TestModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

    public static async updateTest(record : TestModel)
    {
        try
        {
            let response = await axios.put(`${ApiService.API_BASE_PATH}/test/`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TestModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

    public static async deleteTest(record : TestModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/test/${record.testid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }

        return false;
    }

    public static async resetTest(record : TestModel)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/test/reset/${record.testid}`);

            if (response && response.status === 200)
            {
                return true;
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }

        return false;
    }

    public static async startTest(record : TestModel)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/test/start/${record.testid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TestModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }

        return false;
    }

    public static async finishTest(record : TestModel)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/test/finish/${record.testid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TestModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }

        return false;
    }

    public static async abortTest(record : TestModel)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/test/abort/${record.testid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TestModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }

        return false;
    }

	public static async getAllTests()
    {
        try
        {
			let params = 
			{
				v: "v_test_all",
				o: "testdate ASC"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TestModel[];
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

	public static async getTestsOverview()
    {
        try
        {
			let params = 
			{
				v: "v_test_overview",
				w: "statusid <= 22",
				o: "testdate ASC"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TestModel[];
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

	public static async getTestsArchive()
    {
        try
        {
			let params = 
			{
				v: "v_test_overview",
				w: "statusid > 22",
				o: "testdate ASC"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TestModel[];
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

    public static async getAllTestsForCustomer(customerid : string)
    {
        try
        {
			let params = 
			{
				v: "v_test_all",
				w: `customerid = ${customerid}`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TestModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getReference(referenceid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/reference/${referenceid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ReferenceModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

	public static async createReference(record : ReferenceModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/reference/`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as ReferenceModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

    public static async updateReference(record : ReferenceModel)
    {
        try
        {
            let response = await axios.put(`${ApiService.API_BASE_PATH}/reference/`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ReferenceModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

    public static async deleteReference(record : ReferenceModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/reference/${record.referenceid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }

        return false;
    }

	public static async getAllReferences()
    {
        try
        {
			let params = 
			{
				v: "v_reference_all",
				o: "dateinsert ASC"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ReferenceModel[];
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

	public static async getAllAvailableReferences(optionid : string)
    {
        try
        {
			let params = 
			{
				v: "v_reference_all",
                w: `referenceid NOT IN (SELECT referenceid FROM "option_reference" WHERE optionid = ${optionid})`,
				o: "dateinsert ASC"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ReferenceModel[];
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

    public static async getAllReferencesForOption(optionid : string)
    {
        try
        {
			let params = 
			{
				v: "v_reference_all",
				w: `referenceid IN (SELECT referenceid FROM v_option_reference_all WHERE optionid = ${optionid})`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as ReferenceModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getAllFilesForOptionReference(optionid : string, referenceid : string)
    {
        try
        {
			let params = 
			{
				v: "v_file_all",
				w: `fileid IN (SELECT fileid FROM option_reference_file WHERE optionid = ${optionid} AND referenceid = ${referenceid})`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as FileModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async createOptionReferenceFile(record : OptionReferenceFileModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/option_reference_file/`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as OptionReferenceFileModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

    public static async downloadExcel(questionnaireid : number)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/export/xlsx`, {responseType: 'blob'});

            if (response && response.status === 200 && response.data)
            {
                return response.data as Blob;
            }
        }
        catch (error)
        {
        }

        return false;

    }

    public static async getAllCategoriesForTargetGroup(targetgroupid : string)
    {
        try
        {
			let params = 
			{
				v: "v_category_targetgroup_all",
				w: `targetgroupid = ${targetgroupid}`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as CategoryTargetGroupModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getCategoryPercentageSum(targetgroupid : string)
    {
        try
        {
			let params = 
			{
				v: "v_category_targetgroup_sum",
				w: `targetgroupid = ${targetgroupid}`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data[0] as CategoryTargetGroupModel;
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getCategoryTargetGroup(categoryid : string, targetgroupid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/category_targetgroup/${categoryid}/${targetgroupid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as CategoryTargetGroupModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

	public static async createCategoryTargetGroup(record : CategoryTargetGroupModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/category_targetgroup/`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as CategoryTargetgroupModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

    public static async updateCategoryTargetGroup(record : CategoryTargetgroupModel)
    {
        try
        {
            let response = await axios.put(`${ApiService.API_BASE_PATH}/category_targetgroup/`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as CategoryTargetGroupModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

    public static async deleteCategoryTargetGroup(record : CategoryTargetGroupModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/category_targetgroup/${record.categoryid}/${record.targetgroupid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }

        return false;
    }

	public static async downloadParticipantList(testid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/export/xlsx/${testid}`, {responseType: 'blob'});

            if (response && response.status === 200 && response.data)
            {
                return response.data as Blob;
            }
        }
        catch (error)
        {
        }

        return false;
    }

	public static async downloadParticipantResult(participantid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/export/pdf/${participantid}`, {responseType: 'blob'});

            if (response && response.status === 200 && response.data)
            {
                return response.data as Blob;
            }
        }
        catch (error)
        {
        }

        return false;
    }

	public static async downloadParticipantQuestions(participantid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/export/pdf/${participantid}/list`, {responseType: 'blob'});

            if (response && response.status === 200 && response.data)
            {
                return response.data as Blob;
            }
        }
        catch (error)
        {
        }

        return false;
    }

	public static async downloadTestQuestions(testid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/export/pdf/${testid}/form`, {responseType: 'blob'});

            if (response && response.status === 200 && response.data)
            {
                return response.data as Blob;
            }
        }
        catch (error)
        {
        }

        return false;
    }

	public static async downloadTestSolutions(testid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/export/pdf/${testid}/solution`, {responseType: 'blob'});

            if (response && response.status === 200 && response.data)
            {
                return response.data as Blob;
            }
        }
        catch (error)
        {
        }

        return false;
    }

	public static async downloadEvaluation(testid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/export/pdf/${testid}/eval`, {responseType: 'blob'});

            if (response && response.status === 200 && response.data)
            {
                return response.data as Blob;
            }
        }
        catch (error)
        {
        }

        return false;
    }

	public static async downloadFile(fileid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/file/${fileid}/download`, {responseType: 'blob'});

            if (response && response.status === 200 && response.data)
            {
                return response.data as Blob;
            }
        }
        catch (error)
        {
        }

        return false;
    }

	public static async downloadManual()
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/export/manual`, {responseType: 'blob'});

            if (response && response.status === 200 && response.data)
            {
                return response.data as Blob;
            }
        }
        catch (error)
        {
        }

        return false;
    }

    public static async getQuestionOptionCounts(questionid : string)
    {
        try
        {
			let params = 
			{
				v: 'v_question_option_cnt',
				w: `questionid = ${questionid}`,
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as Object;
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async generateQuestionnaire(testid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/test/generate/${testid}`);

            if (response && response.status === 200)
            {
                return response.data;
            }
        }
        catch (error)
        {
        }

        return false;
    }

	public static async replaceQuestion(questionnaireid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/questionnaire/${questionnaireid}/replace`);

            if (response && response.status === 200)
            {
                return true;
            }
        }
        catch (error)
        {
        }

        return false;
    }

    public static async getQuestionnaireForTest(testid : string)
    {
        try
        {
			let params = 
			{
				v: 'v_questionnaire_all',
				w: `testid = ${testid}`,
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as QuestionnaireView[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getOptionsForQuestion(testid : string, questionid : string)
    {
        try
        {
			let params = 
			{
				v: 'v_question_options',
				w: `testid = ${testid} AND questionid = ${questionid}`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as OptionsForQuestionModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getOptionGroups(testid : string, questionid : string)
    {
        try
        {
			let params = 
			{
				v: 'v_group_options',
				w: `testid = ${testid} AND questionid = ${questionid}`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as OptionsGroupModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getTestTargetgroups(testid : string)
    {
        try
        {
			let params = 
			{
				v: 'v_participant_targetgroups',
				w: `testid = ${testid}`
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as TestTargetGroupsModel[];
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getOptionReference(optionid : string, referenceid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/option_reference/${optionid}/${referenceid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as OptionReferenceModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

	public static async createOptionReference(record : OptionReferenceModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/option_reference/`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as OptionReferenceModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async updateOptionReference(record: OptionReferenceModel)
    {
        try
        {
	        let response = await axios.put(`${ApiService.API_BASE_PATH}/option_reference/`, record);
	
    	    if (response && response.status === 200)
        	{
            	if (response.data)
	            {
    	            return response.data as OptionReferenceModel;
        	    }
	        }
    	}
        catch (error)
        {
            console.log(error);
        }
    }

    public static async deleteOptionReference(optionid : string, referenceid : string)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/option_reference/${optionid}/${referenceid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
            console.log(error);
            //ErrorService.process(error);
        }

        return false;
    }

	public static async getAnswerForQuestion(participantid : string, questionid : string)
    {
        try
        {
            let response = await axios.get(`${SurveyService.API_SURVEY_PATH}/answer/${participantid}/${questionid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as AnswerModel;
                }
            }
        }
        catch (error)
        {
        }
    }

    public static async getAllAnswersForParticipant(participantid : string)
    {
        return 0;
    }

    public static async getFile(fileid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/file/${fileid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as FileModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

    public static async deleteFile(fileid : string)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/file/${fileid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }

        return false;
    }

    public static async unlockParticipant(participantid : string)
    {
        try
        {
            let response = await axios.put(`${ApiService.API_BASE_PATH}/participant/${participantid}/unlock`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
        }

        return false;
    }

	public static async getMetricCounts()
    {
        try
        {
			let params = 
			{
				v: "v_metric_counts"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data[0] as MetricCounts;
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getMetricMissingReferences()
    {
        try
        {
			let params = 
			{
				v: "v_metric_missing_reference"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as MetricMissingReference[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getMetricMissingTargetgroups()
    {
        try
        {
			let params = 
			{
				v: "v_metric_missing_targetgroup"
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as MetricMissingTargetgroup[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getMetricTargetGroupCounts()
    {
        try
        {
			let params = 
			{
				v: "v_metric_targetgroup",
			}

            let response = await axios.post(`${ApiService.API_BASE_PATH}/view`, params);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as MetricTargetGroup[];
                }
            }
        }
        catch (error)
        {
        }
    }

	public static async getSource(sourceid : string)
    {
        try
        {
            let response = await axios.get(`${ApiService.API_BASE_PATH}/source/${sourceid}`);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as SourceModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

	public static async createSource(record : SourceModel)
    {
        try
        {
            let response = await axios.post(`${ApiService.API_BASE_PATH}/source/`, record);

            if (response && response.status === 201)
            {
                if (response.data)
                {
                    return response.data as SourceModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

    public static async updateSource(record : SourceModel)
    {
        try
        {
            let response = await axios.put(`${ApiService.API_BASE_PATH}/source/`, record);

            if (response && response.status === 200)
            {
                if (response.data)
                {
                    return response.data as SourceModel;
                }
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }
    }

    public static async deleteSource(record : SourceModel)
    {
        try
        {
            let response = await axios.delete(`${ApiService.API_BASE_PATH}/source/${record.sourceid}`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
            //ErrorService.process(error);
        }

        return false;
    }

	public static async approveParticipant(record : ParticipantModel)
    {
        try
        {
            let response = await axios.patch(`${ApiService.API_BASE_PATH}/participant/approve`, record);

            if (response && response.status === 200)
            {
                return true;
            }
        }
        catch (error)
        {
            console.log(error);
        }

        return false;
    }

	public static async disqualifyParticipant(record : ParticipantModel)
    {
        try
        {
            let response = await axios.patch(`${ApiService.API_BASE_PATH}/participant/disqualify`, record);

            if (response && response.status === 200)
            {
                return true;
            }
        }
        catch (error)
        {
            console.log(error);
        }

        return false;
    }

	public static async approveQuestion(questionnaireid : string)
    {
        try
        {
            let response = await axios.patch(`${ApiService.API_BASE_PATH}/questionnaire/${questionnaireid}/approve`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
            console.log(error);
        }

        return false;
    }

	public static async rejectQuestion(questionnaireid : string)
    {
        try
        {
            let response = await axios.patch(`${ApiService.API_BASE_PATH}/questionnaire/${questionnaireid}/reject`);

            if (response && response.status === 204)
            {
                return true;
            }
        }
        catch (error)
        {
            console.log(error);
        }

        return false;
    }

}
